import React, { useEffect, useRef } from 'react';

import { anelDeFoco, styledDs as styled } from '../../../styles/theme';

export type DsCheckboxProps = {
  label: string;
  checked: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  id?: string;
  onChange: (checked: boolean) => void;
};

const Wrap = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${({ theme }) => theme.font.sizeMd};
  color: ${({ theme }) => theme.colors.textPrimary};

  input {
    width: 16px;
    height: 16px;
    flex: none;
    margin: 0;
    accent-color: ${({ theme }) => theme.colors.accent};
    cursor: pointer;
  }

  input:disabled {
    cursor: not-allowed;
  }

  input:focus-visible {
    ${anelDeFoco()}
  }
`;

export const DsCheckbox: React.FC<DsCheckboxProps> = ({
  label,
  checked,
  indeterminate = false,
  disabled = false,
  id,
  onChange,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate && !checked;
    }
  }, [indeterminate, checked]);

  return (
    <Wrap>
      <input
        ref={inputRef}
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span>{label}</span>
    </Wrap>
  );
};
